import { memo, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { BaseRichEditor, BaseSelect } from '~/components/common';
import { Typography } from '@mui/material';
import { useAppDispatch } from '~/redux/hooks';
import { handleGetTemplate, handleGetTemplates } from '~/thunks/template/templateThunk';
import { handleApiError } from '~/utils/helper';
import { IResponseGetEstimate } from '~/utils/interface/estimate';
import { ITemplate } from '~/utils/interface/job';

type TermAndConditionProps = {
  form: any;
  editData?: IResponseGetEstimate | undefined;
};
function TermAndCondition(props: TermAndConditionProps) {
  const { form } = props;
  const { t } = useTranslation('admin/job');
  const TYPE: string = 'estimateTerm';
  const dispatch = useAppDispatch();
  const [termId, setTermId] = useState<string>('');
  const [terms, setTerms] = useState<ITemplate[]>([]);

  useEffect(() => {
    props.editData?.term && form.setFieldValue('term', props.editData?.term);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const onChangeValue = (value: string) => {
    form.setFieldValue('term', value);
  };

  useEffect(() => {
    (async () => {
      try {
        const result = await dispatch(handleGetTemplates({ limit: 0, type: TYPE })).unwrap();
        setTerms(result.responses as ITemplate[]);
      } catch (e) {
        handleApiError(e);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelectTermTemplates = async (event: React.ChangeEvent<HTMLButtonElement>) => {
    const { value } = event.target;
    setTermId(value);
    const response = await dispatch(handleGetTemplate({ type: TYPE, id: value })).unwrap();
    form.setFieldValue('term', response.content);
  };
  return (
    <Box>
      <Box className='bg-[#F3F9FF] w-full my-4 p-5 font-[600] text-[14px] border-y-2 border-solid border-y-[#e5eaef]'>
        {t('estimate.termAndConditions.title')}
      </Box>
      <Box component='form' className='p-5'>
        <Box className='block right'>
          <Box className='flex justify-end pb-5'>
            <Typography className='px-2 content-center'>
              {t('estimate.termAndConditions.importFromTemplate')}
            </Typography>
            <Box className='w-[200px]'>
              <BaseSelect
                name='termId'
                value={termId}
                options={terms}
                onChange={(event) => handleSelectTermTemplates(event)}
              ></BaseSelect>
            </Box>
          </Box>
        </Box>
        <BaseRichEditor
          onCreateNew={onChangeValue}
          valueProps={form.values.term}
          isError={Boolean(form.errors?.term)}
          errorMessage={form.errors.term}
        />
      </Box>
    </Box>
  );
}

export default memo(TermAndCondition);
